export const addQueryAndHash = (
    url: string,
    query: string | undefined,
    hash: string | undefined
) => {
    const queryPart = query ? `?${query}` : '';
    const hashPart = hash ? `#${hash}` : '';
    return `${url}${queryPart}${hashPart}`;
};
